import { tolgee } from "@/providers/TranslationProvider";

export const getDatePickerErrorMessage = (
  errorMessage: string | undefined
): string | undefined => {
  if (!errorMessage) {
    return undefined;
  }

  switch (errorMessage) {
    case "cardAddDeliveryNote.deliveryNote.errorDeliveryDate":
      return tolgee.t("cardAddDeliveryNote.deliveryNote.errorDeliveryDate");
    case "rushOrderProposal.errorDeliveryDate":
      return tolgee.t("rushOrderProposal.errorDeliveryDate");
    case "rushOrderProposal.choices.error":
      return tolgee.t("rushOrderProposal.choices.error");
    default:
      return errorMessage;
  }
};
